import axios from 'axios';
import { token } from '../../../services/Apis';
import { juegosDeportivosApi } from '../../sistema/deportes/DeportesService';

export const RONDAS_CONST = 'jugadores';

export const allJugadoresService = async (params) => {
  const res = await axios.get(`${juegosDeportivosApi}/${RONDAS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveJugadoresService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(
      `${juegosDeportivosApi}/${RONDAS_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  } else {
    res = await axios.post(`${juegosDeportivosApi}/${RONDAS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneJugadoresService = async (id) => {
  const res = await axios.get(`${juegosDeportivosApi}/${RONDAS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteJugadoresService = async (id) => {
  const res = await axios.delete(
    `${juegosDeportivosApi}/${RONDAS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
